import AbstractService from "../abstract.service";

export default class ReportService extends AbstractService {
  static URI_STATES = new Map([
    ["reports.run", "/reports"],
    ["reports.graph", "/graph"],
    ["reports.run_new_to_brand", "/new-to-brand"],
    ["reports.run_offline_attribution", "/offline-attribution"],
    ["reports.run_audience", "/audience-report"],
    ["reports.run_retail_attribution", "/retail-attribution"],
    ["reports.brand_lift", "/brand_lift_campaigns_report"],
  ]);

  /**
   * Run a report
   * @param {object} data - values of the report form
   * @returns {object} report result
   */
  async run(data) {
    return await this.api_server.post(ReportService.URI_STATES.get("reports.run"), data);
  }

  /**
   * Run a new to brand report
   * @param {object} data - values of the report form
   * @returns {object} report result
   */
  async runNewToBrand(data) {
    return await this.api_server.post(ReportService.URI_STATES.get("reports.run_new_to_brand"), data);
  }

  /**
   * Run an offline attribution report
   * @param {object} data - values of the report form
   * @returns {object} report result
   */
  async runOfflineAttribution(data) {
    return await this.api_server.post(ReportService.URI_STATES.get("reports.run_offline_attribution"), data);
  }

  /**
   * Run an audience report
   * @param {object} data - values of the report form
   * @returns {object} report result
   */
  async runAudience(data) {
    return await this.api_server.post(ReportService.URI_STATES.get("reports.run_audience"), data);
  }

  /**
   * Run a retail attribution report
   * @param {object} data - values of the report form
   * @returns {object} report result
   */
  async runRetailAttribution(data) {
    return await this.api_server.post(ReportService.URI_STATES.get("reports.run_retail_attribution"), data);
  }

  /**
   * Make an API call to download file
   * @param {object} data - values of the report form
   * @returns {object} report result
   */
  async runDownload(data) {
    return await this.api_server.post_download(ReportService.URI_STATES.get("reports.run"), data);
  }

  /**
   * Make an API call to download file
   * @param {object} data - values of the report form
   * @returns {object} report result
   */
  async runNewToBrandDownload(data) {
    return await this.api_server.post_download(ReportService.URI_STATES.get("reports.run_new_to_brand"), data);
  }

  /**
   * Make an API call to download offline attributions
   * @param {object} data - values of the report form
   * @returns {object} report result
   */
  async runOfflineAttributionDownload(data) {
    return await this.api_server.post_download(ReportService.URI_STATES.get("reports.run_offline_attribution"), data);
  }

  /**
   * Make an API call to download audience report
   * @param {object} data - values of the report form
   * @returns {object} report result
   */
  async runAudienceDownload(data) {
    return await this.api_server.post_download(ReportService.URI_STATES.get("reports.run_audience"), data);
  }

  /**
   * Make an API call to download retail attribution report
   * @param {object} data - values of the report form
   * @returns {object} report result
   */
  async runRetailAttributionDownload(data) {
    return await this.api_server.post_download(ReportService.URI_STATES.get("reports.run_retail_attribution"), data);
  }

  /**
   * Get a presigned S3 URL for a brand lift report PDF
   * @param {number} campaignId
   * @returns {Promise}
   */
  async getBrandLiftReport(campaignId) {
    // biome-ignore lint/style/useNamingConvention: <server params>
    return await this.api_server.post(ReportService.URI_STATES.get("reports.brand_lift"), { campaign_id: campaignId });
  }

  /**
   * Get campaigns graph data
   * @param {object} params
   * @returns {Promise}
   */
  async campaignGraph(params = {}) {
    return await this.__graph(Object.assign({ type: "campaign" }, params));
  }

  /**
   * Get strategy graph data
   * @param {object} params
   * @returns {Promise}
   */
  async strategyGraph(params = {}) {
    return await this.__graph(Object.assign({ type: "strategy" }, params));
  }

  /**
   * Get graph data
   * @param {object} params
   * @returns {Promise}
   */
  async __graph(params = {}) {
    return await this.api_server.get(ReportService.URI_STATES.get("reports.graph"), params);
  }
}
